/*
 * Copyright (c) 2022-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {useEffect, useRef, useState} from 'react';
import Tooltip from "./Tooltip.jsx";

function throttle(f, delay) {
    let timer = 0;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => f.apply(this, args), delay);
    }
}

function TextTruncate({className = "", children}) {
    const [isOverflowed, setIsOverflowed] = useState(false);
    const textElement = useRef(null);

    const hasOverflow = () => {
        return (textElement?.current?.scrollWidth ?? 1) > (textElement?.current?.parentNode?.scrollWidth ?? 0);
    };

    useEffect(() => {
        const overflowStatus = hasOverflow();
        if (overflowStatus !== isOverflowed) {
            setIsOverflowed(overflowStatus);
        }

        const resizeObserver = new ResizeObserver(
            throttle(() => {
                const overflowStatus = hasOverflow();
                if (overflowStatus !== isOverflowed) {
                    setIsOverflowed(overflowStatus);
                }
            }, 500)
        );

        if (textElement.current) {
            resizeObserver.observe(textElement.current);
        }

        return () => {
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
        };
    }, [isOverflowed]);

    return (
        <Tooltip
            text={children}
            delay={400}
            className={"w-full"}
            isActive={isOverflowed}>
            <div
                ref={textElement}
                className={`${className ?? ""}`}
                style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                {children}
            </div>
        </Tooltip>
    );
}

export default TextTruncate;